export default "__VITE_ASSET__gHZ7irp4__"